import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { $CurrentAvailableExperienceDataOrNull, $CurrentExperienceStandardKeyword } from '../atoms';
import { useMemo } from 'react';
import { loadable } from 'jotai/utils';
import { ExperienceGPTAnswer } from 'shared/models';

export const useExperienceTitle = (): string => {
  const { t } = useTranslation();
  const standardKeyword = useAtomValue($CurrentExperienceStandardKeyword);
  const loadableCurrentAnswer = useAtomValue(loadable($CurrentAvailableExperienceDataOrNull));
  const thisYear = new Date().getFullYear().toString();

  let currentAnswer: ExperienceGPTAnswer | null = null;

  if (loadableCurrentAnswer.state === 'hasData') {
    currentAnswer = loadableCurrentAnswer.data;
  }

  const publishYear = useMemo(() => {
    if (currentAnswer?.submitTimeStamp) {
      return new Date(currentAnswer.submitTimeStamp * 1000).getFullYear().toString();
    }
    return thisYear;
  }, [currentAnswer]);
  if (!currentAnswer) {
    return `${standardKeyword} | ${publishYear} ${t('seo_searchCard_link_title')}`;
  } else {
    return `${currentAnswer.question} | ${publishYear} ${t('seo_searchCard_link_title')}`;
  }
};
